import { Position, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
  position: Position.TOP
});

export default AppToaster;
